import api from "./api";

const getAll = (params = {}, config = {}) => {
  return api.get("/api/account/get-all", { params, ...config });
};

// Lightweight account→locations tree for pickers (ad-hoc report Customer/
// Location filters). Hits an ungated endpoint so filtering a report doesn't
// require customer:read; returns ids/names only.
const getForAssign = () => {
  return api.get("/api/account/get-for-assign");
};

const getArchived = () => {
  return api.get("/api/account/get-archived");
};

const getOne = (accountId) => {
  return api.get("/api/account/get-one", { params: { accountId } });
};

const saveAccount = (account) => {
  return api.post("/api/account/save", account);
};

const createWithLocations = (data) => {
  return api.post("/api/account/create-with-locations", data);
};

const updateAccount = (account) => {
  return api.post("/api/account/update", account);
};

const assignCustomersToAccount = (data) => {
  return api.post("/api/account/assign-customers", data);
};

const archiveAccount = (accountId) => {
  return api.post("/api/account/archive", { accountId });
};

const restoreAccount = (accountId) => {
  return api.post("/api/account/restore", { accountId });
};

const AccountService = {
  getAll,
  getForAssign,
  getArchived,
  getOne,
  saveAccount,
  createWithLocations,
  updateAccount,
  assignCustomersToAccount,
  archiveAccount,
  restoreAccount,
};

export default AccountService;
